import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  getAuthorizedContactsActions,
  getPermissonRolesAction,
  addContactPermissionAction,
} from "../../actions/UserActions";
import { getBillingItemForpermissions } from "../../actions/BillingActions";
import moment from "moment";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import { cryptoTokenDecode, toastMessage, humanize } from "./../Common/Common";
import * as constant from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import ReactSelect from "react-select";

class CreateContactPermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Contact data that gets read into the system
      // Role and userType should be arrays
      contact: {
        email: "",
        role: "",
        usertype: message.VENDOR,
        firstname: "",
        lastname: "",
        mobileNumber: "",
        ownerId:
          cryptoTokenDecode().usertype === message.ACCTOWNER
            ? localStorage.getItem("ID")
            : localStorage.getItem("ownerId"),
      },
      showLoader: false,
      contactRoleExists: false,
      allContacts: [],
      selectedContact: "",
      filterContact: null,
      contactRequiredErr: false,
      rolesforselectfeild: [],
    };
  }

  componentDidMount() {
    let roles = [];
    this.props.getPermissonRolesAction().then((res) => {
      roles = this.props.roles;
    });
    const today = moment();
    let data = {
      userId:
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId"),
      invoicePeriod: today.format("YYYYMM"),
    };
    // console.log("data", data);
    this.props.getBillingItemForpermissions(data).then((res) => {
      // console.log("response", res.data);
      if (res.status === 200) {
        // console.log("res.data", res.data);
        // console.log("roles-61", roles);
        let checkFor = [message.aiimagetool];
        const hasSome =
          res.data &&
          res.data.length > 0 &&
          checkFor.some((item) => res.data.includes(item));

        // console.log("hasSome", hasSome);
        if (!hasSome) {
          // console.log(" remove");
          const index = roles.findIndex((x) => x.name == "MANAGE_IMAGE_AI");
          // console.log("index-75", index);
          if (index > -1) {
            // only splice array when item is found
            roles.splice(index, 1); // 2nd parameter means remove one item only
          }
        }
        // console.log("2121roles23232", roles);
        this.setState({
          rolesforselectfeild: roles,
        });
        // setBillingItem(res.data);
      }
    });

    this.getAllContacts();
  }

  getAllContacts() {
    this.props
      .getAuthorizedContactsActions()
      .then((res) => {
        //console.log("all contacts", res);
        let contactsRes = res.data;
        let options = [];
        for (var i = 0, len = contactsRes.length; i < len; i++) {
          let item = contactsRes[i];
          let contactObj = {
            label: item.firstname + " " + item.lastname,
            value: item._id,
          };
          options.push(contactObj);
        }

        this.setState({
          allContacts: options,
        });
      })
      .catch((err) => {
        // console.log(err);
      });
  }

  /**
   * @desc add contact
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  addContact(values) {
    this.setState({
      showLoader: true,
    });

    values["roles"] = [values.role];
    values["contactId"] = this.state.filterContact
      ? this.state.filterContact.value
      : "";

    //console.log("addContact values before submit", values);

    this.props.addContactPermissionAction(values).then((res) => {
      this.setState({
        showLoader: false,
      });
      if (res.status === constant.FORBIDDEN) {
        this.setState({
          contactRoleExists: true,
        });
      } else if (res.status === constant.BAD_REQUEST) {
        toastMessage(constant.ERROR, res.data);
      } else {
        toastMessage(constant.SUCCESS, message.ARTIST_PERMISSION_ADDED);
        this.props.onClose();
      }
    });
  }

  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }

  checkValidationsAndSubmit(values, errors) {
    //console.log("valid values", values);
    if (!this.state.filterContact) {
      //console.log("contact not selected");
      this.setState({
        contactRequiredErr: true,
      });
    } else {
      this.addContact(values);
    }
  }

  setContactDetails(contact) {
    // console.log("e contact", contact);
    // console.log("all contact", this.props.contacts);
    let selectedContact = this.props.contacts.find(
      (item) => item._id === contact.value
    );
    //console.log("selected contact", selectedContact);
    var contact = {
      email: selectedContact.email,
      role: "",
      usertype: message.VENDOR,
      firstname: selectedContact.firstname,
      lastname: selectedContact.lastname,
      mobileNumber: selectedContact.mobileNumber,
      ownerId:
        cryptoTokenDecode().usertype === message.ACCTOWNER
          ? localStorage.getItem("ID")
          : localStorage.getItem("ownerId"),
    };
    this.setState({
      contact,
    });
  }

  render() {
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              role: Yup.string()
                .trim()
                .required(message.REQUIRED_VENDOR_TYPE),
            })}
            onSubmit={(values, errors) => {
              this.checkValidationsAndSubmit(values, errors);
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                <>
                  <div className="form-group">
                    <label>
                      Artist<span className="text-danger"> *</span>
                    </label>
                    <ReactSelect
                      isClearable={false}
                      closeMenuOnSelect={true}
                      placeholder="Select artist"
                      options={this.state.allContacts}
                      className="react-select-wrapper react-select-multi react-select-buyer-multi"
                      onChange={(e) => {
                        this.setState({ filterContact: e });
                        this.setContactDetails(e);
                      }}
                      value={this.state.filterContact}
                    />
                    {this.state.contactRequiredErr && (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {message.CONTACT_REQUIRED}
                      </div>
                    )}
                    {this.state.contactRoleExists && (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {message.CONTACT_WITH_ROLE_ALREADY_EXISTS}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Permission<span className="text-danger"> *</span>
                    </label>
                    <div className="c-select">
                      <select
                        className="form-control"
                        name="role"
                        value={values.role}
                        onChange={(e) => {
                          this.setState({ contactRoleExists: false });
                          setFieldValue("role", e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {this.props.roles &&
                          this.props.roles.map((role) => {
                            return (
                              <option key={role._id} value={role._id}>
                                {humanize(role.name)}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    <ErrorMessage
                      name="role"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <Field
                      type="email"
                      className="form-control"
                      name="email"
                      value={values.email}
                      disabled
                      handleChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>First Name</label>
                    <Field
                      type="text"
                      name="firstname"
                      className="form-control field_ucfirst"
                      value={values.firstname}
                      disabled
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name</label>
                    <Field
                      type="text"
                      name="lastname"
                      className="form-control field_ucfirst"
                      value={values.lastname}
                      disabled
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="form-group" hidden={this.state.isEmailValid}>
                    <label>Mobile Number</label>
                    <InputMask
                      mask="999-999-9999"
                      maskChar=""
                      formcontrolprops={{
                        fullWidth: true,
                      }}
                      className="form-control"
                      value={values.mobileNumber}
                      name="mobileNumber"
                      disabled
                    >
                      {(inputProps) => <Field {...inputProps} disabled />}
                    </InputMask>
                  </div>
                  <Button
                    variant="primary"
                    size="sm"
                    className="btn-blue w-140"
                    type="submit"
                  >
                    Add
                  </Button>
                </>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    roles: state.reducer.roles,
    contacts: state.reducer.contacts,
  };
};

export default connect(
  mapStateToProps,
  {
    getAuthorizedContactsActions,
    getPermissonRolesAction,
    addContactPermissionAction,
    getBillingItemForpermissions,
  }
)(CreateContactPermission);
